import {
    PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS,
} from '../constants';


export function setSpecialBonification(value) {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS,
            data: { value }
        })
    }
}